// extracted by mini-css-extract-plugin
export default {"formItem":"single-input-form_formItem__PnTvy","actionButtonsWrapper":"single-input-form_actionButtonsWrapper__uzOS1"};